import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Item } from '@/types/item';
import { Modal } from '@/types/modal';
import Grid, { GridAction, itemCustom, itemLinkButton, itemText } from '@/components/molecules/section/Grid';
import Container from '@/components/molecules/section/Container';
import ModalView from '@/components/modals/Modal';
import { Label, ValueButton, ValueText } from '@/components/atoms/Section';
import { useItemValue, useTab } from '@/hooks/tab';
import { Tab } from '@/types/hashes';

const View: React.FC<{ item: Item }> = ({ item }) => {
  const { t } = useTranslation();
  const [modal, setModal] = useState<Modal | null>(null);

  const [, setInputValue] = useItemValue();
  const [, setTab] = useTab();

  const actions: GridAction[] = [
    {
      kind: 'Button',
      label: t('item.relist.actions.relist_to_seller'),
      onClick: () => setModal({ kind: 'ItemRelistSeller', item, onClose: () => setModal(null) }),
      disabled: !(item.inStock === false),
    },
    {
      kind: 'Button',
      label: t('item.relist.actions.warehouse_relist'),
      onClick: () => setModal({ kind: 'ItemRelistWarehouse', item, onClose: () => setModal(null) }),
      disabled: !(item.inStock === true),
    },
    {
      kind: 'Button',
      label: t('item.relist.actions.relist_to_buyer'),
      onClick: () => setModal({ kind: 'ItemRelistBuyer', item, onClose: () => setModal(null) }),
      disabled: item.enableRelistToBuyer === false || item.orderId == null || item.buyerId == null,
    },
  ];

  const handleItemClick = (id: string) => {
    setInputValue(id);
    setTab(Tab.ITEM);
  };

  const items = [
    itemText(t('item.relist.item_in_stock'), item.inStock ? t('common.yes') : t('common.no')),
    itemLinkButton(t('item.relist.former_vc_ref'), {
      kind: 'Button',
      label: item.formerVcRef ? item.formerVcRef.toString() : '-',
      disabled: !item.formerVcRef,
      onClick: () => {
        if (item.formerVcRef) {
          handleItemClick(item.formerVcRef.toString());
        }
      },
    }),
    itemCustom(
      <>
        <Label labelInfo={{ label: t('item.relist.new_vc_ref') }} />
        {item.newVcRef?.length ? (
          item.newVcRef.map((item) => (
            <ValueButton
              key={item}
              label={item.toString()}
              onClick={() => handleItemClick(item.toString())}
            />
          ))
        ) : (
          <ValueText
            label={'-'}
            kind={'Text'}
          />
        )}
      </>,
    ),
  ];

  return (
    <>
      <Container
        title={t('item.relist.title')}
        actions={actions}
        testId="relist_info"
      >
        <Grid
          column={5}
          items={items}
        />
      </Container>
      <ModalView modal={modal} />
    </>
  );
};

export default View;
